import React from 'react';
import PanelHelpBadge from '../../PanelHelpBadge';

const formatTry = (value) => `${Number(value || 0).toLocaleString('tr-TR', { maximumFractionDigits: 0 })} TL`;

export default function EconomyDeepDiveCard({ economy, onOpenDrawer }) {
  const summary = economy?.summary || {};
  const periodBreakdown = economy?.periodBreakdown || {};

  return (
    <section className="min-h-[248px] rounded-xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-[#101922]">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <h3 className="text-sm font-black text-slate-900 dark:text-white">Ekonomi Derin Görünüm</h3>
          <PanelHelpBadge
            title="Ekonomi Derin Görünüm"
            description="Sipariş dönüşümü ve ekonomik değer metriklerini aynı pencerede birlikte okur."
            interpretation="Dönüşüm düşerken aylık değer artıyorsa sepet başına değer büyümüş olabilir."
            metricExample="Aylık değer yatay, tamamlanan sipariş düşükse alışveriş tamamlanma aksiyonu gerekir."
          />
        </div>
        <button
          type="button"
          onClick={() => onOpenDrawer('economy')}
          className="text-xs font-bold text-primary hover:underline"
        >
          Detaya git →
        </button>
      </div>

      <p className="mt-3 text-2xl font-black text-slate-900 dark:text-white">{formatTry(summary.monthlyValueTry)}</p>
      <p className="text-xs text-slate-500 dark:text-slate-400">Aylık değer</p>

      <ul className="mt-3 space-y-1.5 text-sm">
        <li className="flex items-center justify-between">
          <span className="text-slate-500 dark:text-slate-400">Yıllık değer</span>
          <span className="font-black text-slate-900 dark:text-white">{formatTry(summary.yearlyValueTry)}</span>
        </li>
        <li className="flex items-center justify-between">
          <span className="text-slate-500 dark:text-slate-400">AOV</span>
          <span className="font-black text-slate-900 dark:text-white">{formatTry(summary.aovTry)}</span>
        </li>
        <li className="flex items-center justify-between">
          <span className="text-slate-500 dark:text-slate-400">Dönüşüm</span>
          <span className="font-black text-slate-900 dark:text-white">
            {Number(summary.shoppingConversionRate || 0).toLocaleString('tr-TR')}%
          </span>
        </li>
        <li className="flex items-center justify-between">
          <span className="text-slate-500 dark:text-slate-400">Bu ay tamamlanan sipariş</span>
          <span className="font-black text-slate-900 dark:text-white">
            {Number(periodBreakdown?.month?.completedOrders || 0).toLocaleString('tr-TR')}
          </span>
        </li>
      </ul>
    </section>
  );
}
